module.exports = __webpack_public_path__ + "img/proj-6.17e2c16d.png";